import {atom} from 'recoil'
import {useRecoilState, useResetRecoilState} from 'recoil'

const confrimModalAtom = atom({
	key: 'confrimModalAtom',
	default: null,
})

const confrimModalTitleAtom = atom({
	key: 'confrimModalTitleAtom',
	default: null,
})
const confirmModalEventAtom = atom({
	key: 'confirmModalEventAtom',
	default: null,
})
const confirmModalShowCloseAtom = atom({
	key: 'confirmModalShowCloseAtom',
	default: true,
})

const useConfirmModalAtom = () => {
	const [state, setState] = useRecoilState(confrimModalAtom)
	const resetState = useResetRecoilState(confrimModalAtom)

	const [title, setTitle] = useRecoilState(confrimModalTitleAtom)
	const resetTitle = useResetRecoilState(confrimModalTitleAtom)

	const [eventState, setEventState] = useRecoilState(confirmModalEventAtom)
	const resetEventState = useResetRecoilState(confirmModalEventAtom)

	const [showClose, setShowClose] = useRecoilState(confirmModalShowCloseAtom)
	const resetShowClose = useResetRecoilState(confirmModalShowCloseAtom)

	const setModalEvent = (
		label,
		event,
		showCloseButton = true,
		titleText = null
	) => {
		setState(label)
		setTitle(titleText)
		setEventState(event)
		setShowClose(showCloseButton)
	}

	const confirmEvent = () => {
		eventState()
		resetState()
		resetTitle()
		resetEventState()
		resetShowClose()
	}

	const closeEvent = () => {
		resetState()
		resetTitle()
		resetEventState()
		resetShowClose()
	}

	return [state, setModalEvent, confirmEvent, closeEvent, showClose, title]
}

export default useConfirmModalAtom
